import { render, staticRenderFns } from "./GlobalSearchEvents.vue?vue&type=template&id=efd7c556&"
import script from "./GlobalSearchEvents.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports